import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/pages/Home'
import AddPlugin from '@/components/pages/AddPlugin'
import EditPlugin from '@/components/pages/EditPlugin'
import Test from '@/components/Test'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [{
            path: '/',
            component: Home,
        },
        {
            path: '/add',
            component: AddPlugin,
        },
        {
            path: '/plugins/:id',
            component: EditPlugin,
            props: true,
        },
        {
            path: '/test',
            component: Test,
        },
    ]
})